
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kCWfQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::010e4a044c21a644c0b907c418c4e39c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0448b6391a79a32$var$_react = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0448b6391a79a32$var$_statusWarning = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("ebrpi")));

var $f0448b6391a79a32$var$_warning = $f0448b6391a79a32$var$_interopRequireDefault((parcelRequire("5MbuW")));
function $f0448b6391a79a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0448b6391a79a32$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $f0448b6391a79a32$var$_react.default.createElement($f0448b6391a79a32$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $f0448b6391a79a32$var$_warning.default
    }, props));
$f0448b6391a79a32$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $f0448b6391a79a32$var$_default = module.exports.default = $f0448b6391a79a32$var$StatusWarningIcon;

});


//# sourceMappingURL=status-warning--editor-warning.8773b8c2.js.map
